import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { publicClient } from '~/services';
import { SIGN_IN } from '~/services/auth';

export const MagiclinkButton = ({
  email,
  setEmailSent,
}: {
  email: string;
  setEmailSent: any;
}) => {
  const [t] = useTranslation('locale');
  const [error, setError] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [signIn, { loading }] = useMutation(SIGN_IN, {
    onError: (error) => {
      setError(t('Index.error'));
    },
    client: publicClient,
  });

  useEffect(() => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (regex.test(email)) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [email]);

  const handleClick = async () => {
    try {
      setEmailSent(true);
      await signIn({
        variables: {
          data: {
            email,
            strategy: 'MAGIC_LINK',
          },
        },
      });
    } catch (error) {
      setError('Your email or password is incorrect');
    }
  };

  return (
    <>
      <button
        disabled={disabled || loading}
        onClick={handleClick}
        className="btn btn-primary w-52 rounded-md"
      >
        {t('MagiclinkButton.buttonSend')}
      </button>
      {error && <p className="text-red-500">{error}</p>}
    </>
  );
};
